import React, { useEffect, useRef, useState } from 'react';
import { useIntl } from 'umi';
import { inject, observer, useLocalStore } from 'mobx-react';
import s from './index.less';
import handUpImg from '@/assets/handsUp.svg';
import { meeting as meetingModel } from '@/models';
import HoverIcon from '../BarragePanel/components/HoverIcon';

export enum HandUpStatus {
  on = 1,
  off = 2,
}

interface HandupCountProps {}

const HandupCount: React.FC<HandupCountProps> = inject(({ store }) => {
  return {
    meeting: store.meeting,
  };
})(
  observer((props) => {
    const { formatMessage } = useIntl();
    const [visible, setVisible] = useState<boolean>(false);
    const [count, setCount] = useState<number>(0);
    const [closeCount, setCloseCount] = useState<number>(0);

    const timeoutRef = useRef<any>();
    const { meeting } = useLocalStore(() => {
      return {
        meeting: meetingModel,
      };
    });
    const handleClose = (e: any) => {
      e.stopPropagation();
      setVisible(false);
      setCloseCount(count);
    };

    const handleOpenPeoplePanel = () => {
      meeting?.setPeoplePanelShow(true);
      setVisible(false);
      setCloseCount(count);
    };

    useEffect(() => {
      const count = meeting.sortMembers.filter((item: any) => {
        return item.handupStatus === HandUpStatus.on;
      });
      setCount(count.length);
      !meeting.peoplePanelShow && count.length !== closeCount && setVisible(true);
    }, [meeting.sortMembers, meeting.peoplePanelShow, closeCount]);

    useEffect(() => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }

      timeoutRef.current = setTimeout(() => {
        setVisible(false);
        setCloseCount(count);
      }, 5000);
    }, [count]);

    useEffect(() => {
      if (meeting.peoplePanelShow) {
        setVisible(false);
      }
    }, [meeting.peoplePanelShow]);

    return (
      <>
        {!!count && visible && (
          <div className={s.handupCount} onClick={handleOpenPeoplePanel}>
            <div className={s.countWrapper}>
              <img src={handUpImg} alt="" className={s.img} />
              <span className={s.text}>{formatMessage({ id: 'xHandsRaising' }, { count })}</span>
              <HoverIcon name="icon-close_1" onClick={handleClose} className={s.icon}></HoverIcon>
            </div>
          </div>
        )}
      </>
    );
  })
);
export default HandupCount;
